import { DateInputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { ChangeEvent, InvalidEvent, JSX, useState } from "react";
import { Dispatch } from "redux";
import { setFormValues } from "../CreateEmployeeModalSlice";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    formValues: {
        dateOfBirth: string;
    };
    dispatch: Dispatch;
}

export const DateInputFieldComponent = (props: Props): JSX.Element => {
    const { formValues, dispatch } = props;

    const [dateError, setDateError] = useState<string | null>();
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-employee-modal__form-group"}>
            <label htmlFor={fieldId}>Geboortedatum</label>
            <div ref={fieldRef}>
                <DateInputField
                    required={true}
                    value={formValues?.dateOfBirth}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        setDateError(null);

                        dispatch(
                            setFormValues({
                                ...formValues,
                                dateOfBirth: event.target.value,
                            }),
                        );
                    }}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setDateError("Geboortedatum is verplicht");
                        }
                    }}
                    max={new Date().toISOString().split("T")[0]}
                />
            </div>
            {dateError && <p className={"c-error-message"}>{dateError}</p>}
        </div>
    );
};
